import { Injectable } from '@angular/core';

@Injectable()
export class CatchingErrorsService {

  constructor() { }

  catchingModelState(errors) {
    if (errors.modelstate) {
      return this.modelStateToHtml(errors.modelstate);
    } else {
      return errors.message;
    }
  }
  private modelStateToHtml(modelstate) {
    let html = '<div class="modelStateErrors">';
    const errors = Object.keys(modelstate).map(function(value, key) {
      html += `<h4>${value.split('input.')[1]}</h4>`;
      html += `<ul>`;
      html += `<li> ${modelstate[value].join('</li><li>')}`;
      html += `</ul>`;
    });
    return html + '</div>';
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/A2-utils/ParentClass/catching-errors.service.ts